import React, { Component } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState} from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';


export default class TextEditor extends Component {
    constructor(props) {
        super(props)
       
    }
    // onEditorStateChange: Function = (editorState) => {
    //     this.setState({
    //       editorState:editorState
    //     });
    // };


    handlePastedText = (text, html) => {
        if (this.props.handlePastedText) {
          return this.props.handlePastedText(
            text,
            html,
            EditorState,
            this.onChange
          );
        }
        return false;
    };

    render() {
        
        let { editorState,onEditorStateChange,fpgerror, height } = this.props;
        
        return (
            <>
            <Editor
            editorState={this.props.editorState}
            toolbarClassName="festtoolbar"
            wrapperClassName="sd_text_editor"
            editorClassName="sd_text_editor"
            editorStyle={{ height: `${this.props.height ? height+'px' : '250px'}` }}
            onEditorStateChange={this.props.onEditorStateChange}
            handlePastedText={this.handlePastedText}
           
            toolbar={{
                blockType: {
                    inDropdown: true,
                    options: ['Normal', 'Blockquote'],
                },
                inline: { inDropdown: true },
                list: { inDropdown: true },
                textAlign: { inDropdown: true },
                link: { inDropdown: true },
                history: { inDropdown: true },
                options: ['inline', 'blockType', 'list', 'link', 'textAlign'],

            }}

            
            />
            {fpgerror ? <span className="error">{fpgerror}</span> : ""}
            </>
        )
    }
}
